import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import { Box, Paragraph, Text, TextInput, Button } from 'grommet';
import ModalErrorTimeout from '../Components/ModalErrorTimeout';


class Error extends React.Component {

    render() {
        return (
            <Box className="errorEditPass">
                {this.props.testo ? <Text className='error'>{this.props.testo}</Text> : <Text className='errorhide2'></Text>}
            </Box>
        );
    }
}


class NuovaEmail extends Component {
    static propTypes = {
        match: PropTypes.object,
        location: PropTypes.object,
        history: PropTypes.object
    }
    constructor(props) {
        super(props);
        this.state = {
        }
        this.saveAndContinue = this.saveAndContinue.bind(this);
        this.back = this.back.bind(this);
    }

    saveAndContinue() {
        this.props.updateMail();
    }

    back() {
        this.props.prevStep();
    }

    render() {

        return (

            <Box className='contentbox'>
                {this.props.values.showTimeoutModal ? <ModalErrorTimeout /> : ''}
                <Box direction="column" align='center'>
                    <Box direction='row' >
                        <h1 className='fixFont' level='1' style={{ marginBottom: '50px' }}>Modifica Email</h1>
                    </Box>
                    <Box direction='row' justify='center'>
                        <Paragraph className='textParagraph' style={{textAlign: 'center'}}>Inserire la nuova email e conferma nuova email. La modifica sarà effettuata sulla vecchia email: {this.props.values.obfsMail}</Paragraph>
                    </Box>
                    <form style={{width:'300px'}}>
                        <Box style={{ height: '280px' }}>
                            <Box direction='column' style={{width:'250px', margin:'12px auto'}}>
                                <Text className='label'>NUOVA EMAIL</Text>
                                <TextInput className={`inputFormdisp ${this.props.values.msgEmail ? 'errorBoxInput' : '' }`} onChange={this.props.setNewMail} style={{ textAlign: 'left' }} />
                                <Error testo={this.props.values.msgEmail} />
                            </Box>
                                    
                            <Box direction='column' style={{width:'250px', margin:'12px auto'}}>
                                <Text className='label'>CONFERMA NUOVA EMAIL</Text>
                                <TextInput  className={`inputFormdisp ${this.props.values.msgMailConf ? 'errorBoxInput' : '' }`} onChange={this.props.setConfirmMail} style={{ textAlign: 'left' }} />
                                <Error testo={this.props.values.msgMailConf} />
                            </Box>
                        </Box>
                        <Box justify='center' direction='row'>
                            {/*<Button className='btnform' type='button' style={{ width: '170px', margin: '0 30px 0 0' }} onClick={this.back} >INDIETRO</Button>*/}
                            <Button className='btnform' disabled={this.props.values.disableButtonNewMail} style={{ width: '170px' }} onClick={this.saveAndContinue}>CONFERMA</Button>
                        </Box>
                    </form>
                </Box>
            </Box >
        )
    }
}
export default withRouter(NuovaEmail)